import { useState } from 'react'; // استيراد useState لإدارة حالة المكونات (state)
import { useAuth } from '../Context/Auth'; // استيراد الهُوك المخصص للوصول لدوال المصادقة من الـ Context
import { Link, useNavigate } from 'react-router-dom'; // استيراد useNavigate للتنقل بين الصفحات برمجياً

export default function Register() {
  const navigate = useNavigate(); // إنشاء دالة للتنقل بين الصفحات
  const { registerUser, loading, error, success } = useAuth(); // جلب دالة التسجيل وحالة التحميل والخطأ والنجاح من الـ Context

  // تعريف حالة لتخزين بيانات المستخدم المدخلة من الفورم
  const [user, setUser] = useState({
    email: '',            // البريد الإلكتروني
    fullName: '',         // الاسم الكامل
    phoneNumber: '',      // رقم الهاتف
    password: '',         // كلمة المرور
    confirmPassword: ''   // تأكيد كلمة المرور
  });

  // دالة لتحديث بيانات المستخدم عند إدخال أو تغيير أي حقل في الفورم
  const getUserData = (e) => {
    const { name, value } = e.target; // استخراج اسم الحقل والقيمة المدخلة
    setUser((prev) => ({ ...prev, [name]: value })); // تحديث الحالة بالبيانات الجديدة
  };

  // دالة تنفذ عند إرسال الفورم (الضغط على زر التسجيل)
  const submitRegisterForm = async (e) => {
    e.preventDefault(); // منع إعادة تحميل الصفحة

    // التحقق من أن كل الحقول ممتلئة
    for (let key in user) {
      if (!user[key].trim()) {
        alert('يرجى ملء جميع الحقول بشكل صحيح');
        return; // وقف تنفيذ الدالة
      }
    }

    // التحقق من تطابق كلمة المرور مع تأكيد كلمة المرور
    if (user.password !== user.confirmPassword) {
      alert('كلمتا المرور غير متطابقتين');
      return;
    }

    // تنفيذ التسجيل عبر دالة registerUser القادمة من الـ context
    const result = await registerUser(user);

    // في حالة نجاح التسجيل، يتم التوجيه لصفحة تسجيل الدخول
    if (result) {
      navigate('/login');
    }
  };

  return (
    <section className="vh-100">
      <div className="container-fluid h-custom">
        <div className="row d-flex justify-content-center align-items-center h-100">
          
          {/* الصورة الجانبية */}
          <div className="col-md-9 col-lg-6 col-xl-5">
            <img
              src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
              className="img-fluid"
              alt="Sample"
            />
          </div>

          {/* صندوق الفورم المصغّر */}
          <div className="col-md-7 col-lg-5 col-xl-3">
            <h3 className="mb-4">إنشاء حساب جديد</h3>

            {/* عرض رسالة الخطأ إن وجدت */}
            {error && <div className="alert alert-danger">{error}</div>}

            {/* عرض رسالة النجاح إن وجدت */}
            {success && <div className="alert alert-success">{success}</div>}

            {/* نموذج التسجيل */}
            <form onSubmit={submitRegisterForm}>
              
              {/* حقل الاسم الكامل */}
              <div className="form-outline mb-3">
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  placeholder="الاسم الكامل"
                  onChange={getUserData}
                  className="form-control form-control-lg"
                />
                <label className="form-label" htmlFor="fullName">Full Name</label>
              </div>

              {/* حقل رقم الهاتف */}
              <div className="form-outline mb-3">
                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="رقم الهاتف"
                  onChange={getUserData}
                  className="form-control form-control-lg"
                />
                <label className="form-label" htmlFor="phoneNumber">Phone Number</label>
              </div>

              {/* حقل البريد الإلكتروني */}
              <div className="form-outline mb-3">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="ادخل بريدك الإلكتروني"
                  onChange={getUserData}
                  className="form-control form-control-lg"
                />
                <label className="form-label" htmlFor="email">Email Address</label>
              </div>

              {/* حقل كلمة المرور */}
              <div className="form-outline mb-3">
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="كلمة المرور"
                  onChange={getUserData}
                  className="form-control form-control-lg"
                />
                <label className="form-label" htmlFor="password">Password</label>
              </div>

              {/* حقل تأكيد كلمة المرور */}
              <div className="form-outline mb-3">
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="تأكيد كلمة المرور"
                  onChange={getUserData}
                  className="form-control form-control-lg"
                />
                <label className="form-label" htmlFor="confirmPassword">Confirm Password</label>
              </div>

              {/* زر التسجيل والرابط لتسجيل الدخول */}
              <div className="text-center text-lg-start mt-4 pt-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary btn-lg"
                  style={{ paddingLeft: "2.5rem", paddingRight: "2.5rem" }}
                >
                  {loading ? <i className='fas fa-spinner fa-spin'></i> : 'Register'}
                </button>
                <p className="small fw-bold mt-2 pt-1 mb-0">
                  <Link to="/login">
                  لديك حساب بالفعل؟ <a className="link-danger"> Login</a>
                  </Link>
                  
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
